import { ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_INTERNAL_NOTIFICATIONS_SETTINGS_NEXT_GEN } from '@atlassian/jira-common-constants/src/spa-routes.tsx';
import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types';
import { jsmProjectSettingsUrl } from './common/index.tsx';

export const routeGroupsProjectSettingsServicedeskInternalNotificationsNextGenRoute: InvariantRoute =
	{
		name: ROUTE_NAMES_PROJECT_SETTINGS_SERVICEDESK_INTERNAL_NOTIFICATIONS_SETTINGS_NEXT_GEN,
		path: `${jsmProjectSettingsUrl}/internal-notifications`,
	};
